import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import PropTypes from 'prop-types';

import CheckboxGroup from 'components/common/CheckboxGroup/CheckboxGroup';
import { updateTemplateValuesListFieldValue } from 'graphql/operations';
import { createSelectionValidationFn } from 'utils/validations/validations';
import SaveTemplateAnswerHOC from '../SaveTemplateAnswerHOC';
import TemplateFieldUpdatesHOC from '../TemplateFieldUpdatesHOC';

export const TemplateCheckboxAnswer = props => {
  const { question, disabled, save } = props;
  const { minimumSelection, maximumSelection, calculated } = question;
  const { t } = useTranslation();
  const options = question.possibleValues.map(valuesListField => ({ value: valuesListField.value, label: valuesListField.value }));

  const handleValidationError = useCallback(() => {
    save.cancel();
  }, [save]);

  const handleChange = useCallback(
    selectedValues => {
      save(selectedValues);
    },
    [save]
  );

  const inputValidation = createSelectionValidationFn(minimumSelection, maximumSelection);

  return (
    <CheckboxGroup
      t={t}
      options={options}
      disabled={calculated || disabled}
      checked={question.listValue}
      onChange={handleChange}
      inputValidation={inputValidation}
      onValidationError={handleValidationError}
    />
  );
};

TemplateCheckboxAnswer.defaultProps = {
  disabled: false
};

TemplateCheckboxAnswer.propTypes = {
  disabled: PropTypes.bool,
  // TODO: Fix this...
  /* eslint-disable react/forbid-prop-types */
  save: PropTypes.any.isRequired,
  question: PropTypes.object.isRequired
  /* eslint-enable react/forbid-prop-types */
};

export const TemplateCheckboxAnswerHOC = compose(
  withApollo,
  graphql(updateTemplateValuesListFieldValue, { name: 'fieldMutation' }),
  TemplateFieldUpdatesHOC,
  SaveTemplateAnswerHOC,
  mapProps(props => ({
    question: props.question,
    save: props.save,
    disabled: props.disabled,
    templateId: props.assessmentId
  }))
);

export default TemplateCheckboxAnswerHOC(TemplateCheckboxAnswer);
